/** 从 18 位身份证号解析出生日期、性别 */
export function parseIdCardFront(idCard) {
  const text = String(idCard || '').trim().toUpperCase();
  if (!/^\d{17}[\dX]$/.test(text)) return null;

  const birthStr = text.substring(6, 14);
  const year = birthStr.substring(0, 4);
  const month = birthStr.substring(4, 6);
  const day = birthStr.substring(6, 8);
  const birthDate = `${year}-${month}-${day}`;

  if (Number.isNaN(Date.parse(`${birthDate}T00:00:00`))) return null;

  const genderCode = parseInt(text.charAt(16), 10);
  const gender = genderCode % 2 === 1 ? 1 : 2;

  return { birthDate, gender };
}

export const ID_CARD_PATTERN = /^\d{17}[\dX]$/;
